import Drift from 'drift-zoom'
import log from 'salvo-lite/log'

class Zoom {
    constructor (theme, elem) {
        this._elem = elem
        this._drift = null
        this._options = {
            // Prefix for generated element class names (e.g. `my-ns` will
            // result in classes such as `my-ns-pane`. Default `drift-`
            // prefixed classes will always be added as well.
            namespace: null,
            // Whether the ZoomPane should show whitespace when near the edges.
            showWhitespaceAtEdges: false,
            // Whether the inline ZoomPane should stay inside
            // the bounds of its image.
            containInline: true,
            // How much to offset the ZoomPane from the
            // interaction point when inline.
            inlineOffsetX: 0,
            inlineOffsetY: 0,
            // A DOM element to append the inline ZoomPane to.
            inlineContainer: this._elem,
            // Which trigger attribute to pull the ZoomPane image source from.
            sourceAttribute: 'data-zoom',
            // How much to magnify the trigger by in the ZoomPane.
            // (e.g., `zoomFactor: 3` will result in a 900 px wide ZoomPane image
            // if the trigger is displayed at 300 px wide)
            zoomFactor: 2,
            // A DOM element to append the non-inline ZoomPane to.
            // Required if `inlinePane !== true`.
            // paneContainer: document.body,
            paneContainer: this._elem.previousElementSibling,
            // When to switch to an inline ZoomPane. This can be a boolean or
            // an integer. If `true`, the ZoomPane will always be inline,
            // if `false`, it will switch to inline when `windowWidth <= inlinePane`
            // inlinePane: 375,
            inlinePane: false,
            // If `true`, touch events will trigger the zoom, like mouse events.
            handleTouch: true,
            // If present (and a function), this will be called
            // whenever the ZoomPane is shown.
            onShow: () => {
                this._elem.style.opacity = 0
            },
            // If present (and a function), this will be called
            // whenever the ZoomPane is hidden.
            onHide: () => {
                this._elem.style.opacity = 1
            },
            // Add base styles to the page. See the "Theming"
            // section of README.md for more information.
            injectBaseStyles: true,
            // An optional number that determines how long to wait before
            // showing the ZoomPane because of a `mouseenter` event.
            hoverDelay: 0,
            // An optional number that determines how long to wait before
            // showing the ZoomPane because of a `touchstart` event.
            // It's unlikely that you would want to use this option, since
            // "tap and hold" is much more intentional than a hover event.
            touchDelay: 0,
            // If true, a bounding box will show the area currently being previewed
            // during mouse hover
            hoverBoundingBox: false,
            // If true, a bounding box will show the area currently being previewed
            // during touch events
            touchBoundingBox: false,
            // A DOM element to append the bounding box to.
            boundingBoxContainer: this._elem,
            showAbove: 0,
            ...JSON.parse(this._elem.dataset.options ? this._elem.dataset.options : '{}')
        }
        if (typeof this._options.paneContainer === 'string') {
            this._options.paneContainer = document.querySelector(this._options.paneContainer)
        }
        if (this._options.mobileOnly) {
            this._options.showBelow = 769
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        log.debug(this.constructor.name, 'Initializing', this)
        if (this._options.showAbove && window.innerWidth <= this._options.showAbove) {
            return false
        }
        if (this._options.showBelow && window.innerWidth >= this._options.showBelow) {
            return false
        }
        this._drift = new Drift(this._elem, this._options)
        log.debug(this.constructor.name, 'Initialized', this)
    }
}
export default Zoom



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Zoom.js